// extracted by mini-css-extract-plugin
module.exports = {"container":"_2S7yit5_mlsvoOujPSrlJR"};